import React, { useContext } from 'react';
import { ContextPaymentTerms } from '../../contexts/PaymentTermsContext';
import NonEditionContent from './NonEditionContent';
import EditionContent from './EditionContent';
import CardTitle from '../components/CardTitle';
import Card from '../../muiComponents/Card';

const PaymentCard = props => {
    const { paymentData } = props;
    const { openedCard } = useContext(ContextPaymentTerms);

    const isThisCardOpened = openedCard === paymentData.Id;

    const renderContent = () => {
        if (!openedCard) {
            //ninguna cardEstá abierta
            return <NonEditionContent paymentProfile={paymentData} />;
        } else if (openedCard && isThisCardOpened) {
            // la tarjeta que está abierta es esta
            return <EditionContent paymentProfile={paymentData} />;
        } else {
            // hay OTRA tarjeta abierta
            return (
                <CardTitle
                    isEditButtonVisible={false}
                    title={paymentData.Name}
                />
            );
        }
    };

    return (
        <Card className='padding-inline40 padding-block-30 flex-column gap-30 '>
            {renderContent()}
        </Card>
    );
};

export default PaymentCard;
